export default "__VITE_ASSET__ef9ba1ae__"